import React from 'react';
import { Box, Flex, Text } from 'rebass';
import ThirdPanePagination from './ThirdPanePagination';
import ThirdPaneToggle from './ThirdPaneToggle';

export interface ThirdPaneHeaderProps {
  title: string;
  onPrev?: () => void;
  onNext?: () => void;
  prevEnabled?: boolean;
  nextEnabled?: boolean;
  forwardedRef?: React.RefObject<HTMLElement>;
  children?: React.ReactNode;
  onToggle?: (visible: boolean) => void;
}

const ThirdPaneHeader = (props: ThirdPaneHeaderProps): JSX.Element => {
  return (
    <Box
      sx={{
        position: 'relative',
        borderBottom: '1px solid',
        borderBottomColor: 'tableBorder',
        zIndex: 3,
        flexGrow: 0,
      }}
      bg="background"
      ref={props.forwardedRef}
    >
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        px={4}
        py={3}
      >
        {props.onToggle && (
          <ThirdPaneToggle visible={true} onToggle={props.onToggle} />
        )}
        <Text variant="heading2">{props.title}</Text>
        <ThirdPanePagination
          prevEnabled={props.prevEnabled}
          onPrev={props.onPrev}
          nextEnabled={props.nextEnabled}
          onNext={props.onNext}
        />
      </Flex>
      {props.children && (
        <Box
          px={20}
          pb={3}
          sx={{
            whiteSpace: 'nowrap',
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            '> button': {
              verticalAlign: 'middle',
              marginRight: 2,
              flexShrink: 0,
            },
            '> *:last-child': {
              marginRight: 0,
            },
          }}
        >
          {props.children}
        </Box>
      )}
    </Box>
  );
};

export default ThirdPaneHeader;
